import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";

export interface IWinbooksExportOptions {
	bookYear:number;
	beginDate?:Date;
	endDate?:Date;
	exportContacts:boolean;
	exportSales:boolean;
}

export class WinbooksServiceClass {
	private readonly baseUrl:string = `${ServerConfig.host}/winbooks`;
	private readonly authUrl:string = `${ServerConfig.auth}/auth/winbooks`;

	async isActiveForDossier():Promise<boolean> {
		try {
			let result = await Axios.get(`${this.authUrl}/status`);
			return result.data?.Active == true;
		} catch (err) {
			return false;
		}
	}

	async export(options:IWinbooksExportOptions):Promise<Blob> {
		let body = {
			bookYear: options.bookYear,
			beginDate: options.beginDate,
			endDate: options.endDate,
			exportContacts: options.exportContacts,
			exportSales: options.exportSales
		};
		let result = await Axios.post(`${this.baseUrl}/export`, body, {responseType: "blob"});
		return result.data as Blob;
	}
}

export const WinbooksService = new WinbooksServiceClass();
